import { ReferenceType } from "../interfaces/referenceType";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
    ? PROD_API_URL
    : DEV_API_URL;

export const getReferenceTypes = async (): Promise<ReferenceType[]> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  try {
    const response = await fetch(
      `${apiBaseUrl}/api/ReferenceType/GetReferenceTypes`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch reference types");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching reference types:", error);
    throw error;
  }
};
